import toast from 'react-hot-toast';
import APIInvoke from '../../utils/APIInvoke';
import { setLoading } from '../../template/app-actions';
import { COLLECTION_CLEAN_FILTERS, COLLECTION_SET_STATE } from '../../redux/redux-const';
import store from '../../redux/store';
import { initialState } from '../../redux/reducers/collection-store';
import { getOperators } from '../../components/QueryBuilder/QueryBuilder';
import { DateTime } from 'luxon';


const getState = () => {
    return store.getState().pages.collection
}

export const setState = (state) => {
    const currentState = getState()
    store.dispatch({ type: COLLECTION_SET_STATE, payload: { ...currentState, ...state } })
}


export const deleteDocument = async (project, collection, id) => {
    try {
        setLoading(true)
        const state = getState()
        const response = await (await APIInvoke.invokeDELETE(`/projects/${project}/collections/${collection}/documents/${id}`)).json()
        if (response.ok) {
            toast.success(response.message)
            setState({
                items: state.items.filter(x => x.id !== state.showDeleteDialog.payload.id),
                showDeleteDialog: { open: false, payload: null }
            })
        } else {
            toast.error(response.message)
        }
    } catch (error) {
        toast.error("Unxpected error")
    } finally {
        setLoading(false)
    }

}

export const fetchCollection = async (project, collection) => {
    try {
        setLoading(true)
        const response = await (await APIInvoke.invokeGET(`/projects/${project}/collections/${collection}`)).json()
        if (response.ok) {
            setState({
                fields: response.body.schema.fields.map(field => ({
                    name: field.fieldName,
                    placeholder: field.placeholder,
                    label: field.fieldName,
                    inputType: field.type === "datetime" ? "datetime-local" : field.type,
                    valueEditorType: field.type === "datetime" ? "datetime-local" : field.type,
                    operators: getOperators(field.type)
                }))
            })
        } else {
            toast.error(response.message)
        }
    } catch (error) {
        console.error("Error lo load collection", error)
    } finally {
        setLoading(false)
    }
}

export const fetchDocuments = async (project, collection, query) => {
    try {
        setLoading(true)
        const state = getState()
        const query64 = btoa(query);

        const startTime = DateTime.now()
        const rawResponse = await APIInvoke.invokeGET(`/projects/${project}/collections/${collection}/documents/query?query=${query64}&page=${state.currentPage}&size=${state.pageSize}&projection=id,key,project,collection,lastUpdateBy,lastUpdateAt,lastReceivedAt,lastRevision,schemaErrors,isValid`)
        if (rawResponse.status === 408) {
            toast.error("Timeout to execute query, try create a more specific query, the response time was " + DateTime.now().diff(startTime, 'seconds').seconds + " seconds");
            return;
        }
        const response = await (rawResponse).json()
        if (response.ok) {
            setState({
                items: response.body.items,
                totalItems: response.body.totalItems,
                currentPage: response.body.currentPage,
                totalPages: response.body.totalPages,
                pageSize: response.body.pageSize
            });
        } else {
            toast.error(response.message)
        }
    } catch (error) {
        console.error("Error lo load page", error)
    } finally {
        setLoading(false)
    }
}

export const onRowsPerPageChange = (newSize) => {
    const state = getState()
    setState({
        //...initialState,
        //items: state.items,
        pageSize: newSize
    });
}


export const toggleDeleteDialog = (event, payload) => {
    event.stopPropagation();
    const currentState = getState()
    setState({
        showDeleteDialog: {
            open: !currentState.showDeleteDialog.open,
            payload
        }
    })
}

export const handleChangePage = (e, newPage) => {
    setState({
        currentPage: newPage
    });
}

export const cleanFilters = () => {
    setState({ queryBuilder: { ...initialState.queryBuilder } })
}



export const restoreQueryParams = (project, collection) => {
    const initialQuery = {
        combinator: 'and',
        rules: [
            {
                field: 'lastReceivedAt',
                operator: '>=',
                value: DateTime.now().minus({ days: 1 }).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm") // "2024-10-30T12:00"
            }
        ],
    };

    const searchParams = new URLSearchParams(window.location.search);
    let query = undefined;
    if (searchParams.get('query')) {
        query = JSON.parse(atob(searchParams.get('query')));
        const currentPage = searchParams.get('currentPage') || 0;
        const pageSize = searchParams.get('pageSize') || 10;

        const newState = {
            ...initialState,
            query: query ? query.query : undefined,
            queryBuilder: query ? query.queryBuilder : initialQuery,
            currentPage,
            pageSize
        };
        return newState;
    } else if (sessionStorage.getItem(`${project}-${collection}-query`)) {
        return {
            ...initialState,
            ...JSON.parse(sessionStorage.getItem(`${project}-${collection}-query`))
        }
    } else {
        const newState = {
            ...initialState,
            query: undefined,
            queryBuilder: initialQuery,
            currentPage: 0,
            pageSize: 10
        };
        return newState;
    }


}